/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_radians.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a number in degrees to radians.',
  examples: [
    'ROW deg = [90.0, 180.0, 270.0]\n| EVAL rad = TO_RADIANS(deg)',
  ],
  params: {
    number: 'Input value. The input can be a single- or multi-valued column or an expression.',
  },
};

export default docs;
